export default __webpack_public_path__ + "static/media/chani sleepy.674e6d07.svg";